import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class HttpErrorEnhancerInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Logger.debug('HttpErrorEnhancerInterceptor', req, next)
    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        let updatedError = err;

        // Add the method to the error. This is necessary to correctly translate exceptions from the backend
        if (err.error) {
          if (typeof err.error === 'string') {
            updatedError = new HttpErrorResponse({
              ...err,
              error: {
                data: err.error,
                method: req.method,
              },
            });
          } else {
            updatedError.error.method = req.method;
          }
        }

        return throwError(() => updatedError);
      })
    );
  }
}
